<template>
  <v-app style="background-color: #dbdbdb" v-if="isBootstrapped">
    <notifications position="top center" :duration="4000" />
    <notifications group="actions-notification" position="top center" :duration="4000">
      <template v-slot:body="{ item, close }">
        <div class="red white--text pa-2">
          <p class="body-1 mb-0">{{ item.title }}</p>
          <span class="body-2 font-weight-light">{{ item.text }}</span>
          <div class="d-flex justify-end">
            <v-btn x-small text @click="close">
              Close
            </v-btn>
            <v-btn class="white--text ml-1" outlined x-small @click="item.data.callback()">
              Retry
            </v-btn>
          </div>
        </div>
      </template>
    </notifications>
    <vue-headful :title="$t('app.title', { companyName: this.companyName })" />
    <v-main id="main-view">
      <top-bar-header v-if="showSidebar" />
      <v-container fluid fill-height :class="full ? 'pa-0' : 'px-10'">
        <navigation v-if="showSidebar && hasAccess(CORP_ADMIN)" :displayName="meDisplayName" />
        <fm-navigation v-if="showSidebar && hasAccess(CHANNEL_ADMIN)" :displayName="meDisplayName" />
        <router-view id="main-router-view" :class="full ? 'ma-0 full' : ''" />
      </v-container>
      <version />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { initLocale } from "@/mixins/language.mixins";
import { initBookingChannel, bookingChannelComputed } from "@/mixins/bookingChannel.mixins";
import Navigation from "@/components/navigation/Navigation.vue";
import TopBarHeader from "@/components/navigation/TopBarHeader.vue";
import { getMe } from "@/mixins/users.mixins";
import Version from "./components/Version.vue";
import { getRoles } from "@/mixins/authentication.mixins";
import { CORP_ADMIN, CHANNEL_ADMIN } from '@/helpers/userRoles';
import FmNavigation from "@/components/navigation/FMNavigation.vue";
import {BusinessBookerEvent} from "@/core/tracking/businessBookerEvent/BusinessBookerEvent";
import {
  BusinessBookerEventManager
} from "@/core/tracking/businessBookerEvent/BusinessBookerEventManager";

export default {
  data() {
    return {
      isBootstrapped: false,
      CORP_ADMIN,
      CHANNEL_ADMIN,
    };
  },
  components: {
    FmNavigation,
    Navigation,
    TopBarHeader,
    Version,
  },
  mixins: [initBookingChannel, bookingChannelComputed, getMe, getRoles, initLocale],
  async created() {
    if (this.token) {
      await this.$store.dispatch('users/getMe');

      const meIdToken = await this.$store.dispatch('users/getDecodedIdToken');

      BusinessBookerEvent.register({
        getCurrentAuthUserFn: () => {
          return {
            id: meIdToken.sub,
            email: meIdToken.email,
            roles: meIdToken.roles,
          };
        },
        getBookingChannelIdFn: () => {
          return this.getChannelId;
        },
        businessBookerEventManager: new BusinessBookerEventManager({
          storeEventCallbackFn: async (events) => {
            await this.$store.dispatch('businessBookerEventApiStore/createEvents', {
              payload: events,
            });
          },
        })
      });
    }

    await this.initLocale();

    this.isBootstrapped = true;
  },
  async mounted() {
    await this.$store.dispatch("users/getUserRole");
  },
  computed: {
    ...mapGetters("authentication", ["idToken"]),
    ...mapGetters('accountsApiStore', ['accountSelected']),
    showSidebar() {
      return this.$route.meta?.sidebar;
    },
    full() {
      return this.$route.meta?.full;
    },
  },
  watch: {
    idToken() {
      this.$store.dispatch("users/getUserRole");
    },
  },
};
</script>

<style lang="sass" scoped>
#main-view
  overflow-y: hidden

#main-router-view
  height: 100%
  width: 100%

#main-router-view.full
  max-width: initial
</style>
